export const tweetsPath = {
  /* inject path */
  TWEET_SENTIMENT_ANALYSIS: '/tweets/tweet-sentiment-analysis/:id/:remoteId',
  TWEET_SENTIMENT_ANALYSIS_URI: '/tweets/tweet-sentiment-analysis',
  ADD_NEW_TWEET: '/tweets/add-new-tweet',
  TWEET_DETAILS: '/tweets/tweet-details/:id',
  TWEET_DETAILS_URI: '/tweets/tweet-details',
  DASHBOARD: '/tweets/dashboard',
  TWEETS_TABLE: '/tweets/tweets-table',
};
